@let disabledIdsVal = disabledIds();
@let itemsVal = selectTeamMembersController.items();
@let totalCountVal = selectTeamMembersController.totalCount();
@let isLoadingVal = selectTeamMembersController.isLoading();
@let selectedIdsSize = selectTeamMembersController.selectedIdsSize();

<rt-dialog-header [heading]="header()" [subheading]="subheader()" />

<rt-dialog-body>
  @if (totalCountVal === undefined || itemsVal === undefined) {
    <div
      layout
      layout-full-height
      layout-full-width
      layout-align-items-center
      layout-justify-center
    >
      <rt-spinner />
    </div>
  }
  @if (totalCountVal !== null && itemsVal) {
    <div column-layout layout-full-width>
      <rt-box variant="vertical no-padding">
        <div class="search">
          <rt-form-field>
            <rt-input
              [formControl]="queryControl"
              variant="rounded"
              [placeholder]="'tlc.select_team_members_dialog.search_placeholder' | translate"
              [hasClearButton]="true"
              (reset)="queryControl.reset('')"
            >
              <rt-icon name="search" prefix />
            </rt-input>
          </rt-form-field>
        </div>

        <rt-divider variant="line" />
        @if (totalCountVal > 0) {
          <virtual-scroller
            #scroll
            [executeRefreshOutsideAngularZone]="true"
            [scrollThrottlingTime]="0"
            [scrollAnimationTime]="0"
            [items]="itemsVal"
            (vsEnd)="selectTeamMembersController.fetchMore($event)"
            (vsUpdate)="cdRef.detectChanges()"
            [class.loading]="isLoadingVal"
          >
            @for (user of scroll.viewPortItems; track user.guid) {
              <div
                [rtTooltipMaxWidth]="260"
                [rtTooltip]="
                  disabledIdsVal[user.guid] &&
                  ('tlc.select_team_members_dialog.already_added' | translate)
                "
                rtTooltipPosition="left"
                [class.disabled]="disabledIdsVal[user.guid]"
                class="result"
              >
                <rt-group
                  (click)="
                    selectTeamMembersController.toggleAssignment(
                      user,
                      disabledIdsVal[user.guid],
                      $event
                    )
                  "
                  variant="horizontal"
                >
                  <rt-checkbox
                    (click)="
                      selectTeamMembersController.toggleAssignment(
                        user,
                        disabledIdsVal[user.guid],
                        $event
                      )
                    "
                    [checked]="
                      disabledIdsVal[user.guid] ||
                      selectTeamMembersController.selectedIds.has(user.guid)
                    "
                    [disabled]="disabledIdsVal[user.guid]"
                    [value]="$any(user.guid)"
                  />
                  <rt-avatar
                    [type]="!!user.avatarThumbUrl ? 'image' : 'initials'"
                    [imageSrc]="user.avatarThumbUrl"
                    [fullName]="user.fullName"
                    [context]="'admin'"
                  />
                  <div layout-vertical margin-left-small>
                    <rt-heading>
                      <rt-truncate> {{ user.fullName }}</rt-truncate>
                    </rt-heading>
                    @if (user.hasWorkEmail && user.email) {
                      <span
                        ><rt-truncate>{{ user.email }}</rt-truncate></span
                      >
                    } @else if (!user.hasWorkEmail && user.login) {
                      <span
                        ><rt-truncate>{{ user.login }}</rt-truncate></span
                      >
                    }
                  </div>
                </rt-group>
                <rt-divider />
              </div>
            }
          </virtual-scroller>
        }
        @if (!isLoadingVal && totalCountVal === 0) {
          <div layout layout-full-height layout-align-items-center layout-justify-center>
            @if (queryControl.value) {
              <rt-empty-state
                [icon]="'search'"
                [title]="'tlc.select_team_members_dialog.search_empty_state' | translate"
                variant="small"
                padding
              >
                <rt-button (click)="queryControl.reset('')" variant="tertiary">
                  {{ 'tlc.select_team_members_dialog.clear_search' | translate }}
                </rt-button>
              </rt-empty-state>
            }
            @if (!queryControl.value) {
              <rt-empty-state
                [title]="'tlc.select_team_members_dialog.search_empty_state' | translate"
                icon="people"
                variant="small"
                padding
              />
            }
          </div>
        }
        @if (isLoadingVal && totalCountVal === 0) {
          <div layout layout-full-height layout-align-items-center layout-justify-center>
            <rt-spinner />
          </div>
        }
      </rt-box>
    </div>
  }
</rt-dialog-body>

<rt-dialog-footer>
  <rt-button (click)="closeDialog()" variant="plain">
    {{ 'tlc.common.cancel' | translate }}
  </rt-button>
  <rt-button
    [disabled]="selectedIdsSize === 0"
    [loading]="saveLoading()"
    (click)="submit()"
    variant="primary"
  >
    @if (ctaButtonText()) {
      {{ ctaButtonText() }}
    } @else {
      {{ 'tlc.select_team_members_dialog.add_members' | translate: { count: selectedIdsSize } }}
    }
  </rt-button>
</rt-dialog-footer>
